// extracted by mini-css-extract-plugin
export var main = "Index-module--main--dMyDe";
export var container = "Index-module--container--49Tav";
export var profileImage = "Index-module--profile-image--3G7Xs";
export var info = "Index-module--info--2zaG_";
export var link = "Index-module--link--261Px";